const system_limit = {
    limit_exceeded: 'Sistem limitine ulaştınız. Yardım için lütfen destek ekibiyle iletişime geçin.',
};
export default Object.freeze(system_limit);
